import Navigation from "../components/site/Navigation";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Expertise from "../components/site/Expertise";
import Portfolio from "../components/site/Portfolio";
import Editorial from "../components/site/Editorial";
// import VintageVault from "../components/site/VintageVault"; // Hidden — reselling paused
import Advocacy from "../components/site/Advocacy";
// import ShopPicks from "../components/site/ShopPicks"; // Hidden until real affiliate links are ready
// import Testimonials from "../components/site/Testimonials"; // Hidden until real testimonials collected
import Newsletter from "../components/site/Newsletter";
import Contact from "../components/site/Contact";
import Booking from "../components/site/Booking";
import Footer from "../components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-cream font-body text-navy">
      <Navigation />
      <Hero />
      <About />
      <Expertise />
      <Portfolio />
      <Editorial />
      {/* <VintageVault /> */}
      <Advocacy />
      {/* <ShopPicks /> */}
      {/* <Testimonials /> */}
      <Newsletter />
      <Contact />
      <Booking />
      <Footer />
    </main>
  );
}
